import { Navigate, Outlet } from "react-router";

import { FullScreenLoader } from "@punto/ui/components/full-screen-loader";

import { useAbility } from "@/modules/abilities";
import { type Subjects } from "@/modules/abilities/abilities";
import { useUser } from "@/modules/auth/hooks/use-user";

import { useBaseRoute } from "./use-base-route";

interface AbilityRouteProps {
  subject: Subjects;
}

/**
 * Route guard for a product area (P-3096). Hiding the nav entry is cosmetic;
 * this blocks direct navigation too. The API is the real enforcement
 * (`@RequiresAbility`). Waits for /users/me: before it lands the ability is
 * empty, and redirecting then would throw the user out on every reload.
 */
const AbilityRoute = ({ subject }: AbilityRouteProps) => {
  const { user } = useUser();
  const ability = useAbility();
  const baseRoute = useBaseRoute();

  if (!user) {
    return <FullScreenLoader />;
  }

  if (!ability.can("manage", subject)) {
    return <Navigate to={baseRoute} replace />;
  }

  return <Outlet />;
};

export { AbilityRoute };
